import { z } from "zod";
import { PartialUserFieldsSchema } from "./User";

export const UserUserAbsenceLimitFieldsSchema = z.object({
  id: z.number(),
  year: z.number(),
  days_of_leave_per_year: z.number(),
  user: PartialUserFieldsSchema,
});
export const PartialUserUserAbsenceLimitFieldsSchema =
  UserUserAbsenceLimitFieldsSchema.deepPartial();

export type UserUserAbsenceLimitFields = z.infer<
  typeof UserUserAbsenceLimitFieldsSchema
>;
export type PartialUserUserAbsenceLimitFields = z.infer<
  typeof PartialUserUserAbsenceLimitFieldsSchema
>;
export type UserUserAbsenceLimit = z.infer<
  typeof UserUserAbsenceLimitFieldsSchema
>;
